<app-navbar></app-navbar>
<div class="row pl-5 pt-5 mt-5">
    <h2 translate>publi.title</h2>
</div>
<div class="row">
    <div translate class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-3 pl-5 px-sm-5 px-md-5 sobre_text">publi.description
        <div class="row" style="font-size: 2rem;">
            <a href="https://lucasbsilva29.medium.com/" class="text-white ml-3 mt-2 icon">
                <fa-icon [icon]="['fab', 'medium']"></fa-icon>
            </a>
            <a href="https://dev.to/lucs1590" class="text-white ml-2 mt-2 icon">
                <fa-icon [icon]="['fab', 'dev']"></fa-icon>
            </a>
        </div>
    </div>
    <!-- <div>
        <img src="../../../assets/img/writer.jpeg" class="img-fluid" alt="Writer Image"
            style="height: 15rem;width: 60rem;object-fit: cover;">
    </div> -->
</div>
<div class="d-flex flex-wrap text-dark justify-content-around pb-4">

    <ng-container *ngIf="publications.length; else skeletonTemplate">
        <div class="card real-card mt-5 text-white bg-dark border-white rounded-0 border-right-0 border-left-0"
            *ngFor="let pub of publications">
            <div class="card-body">
                <img [src]="pub.image" class="thumb mr-2 mb-1" alt="Thumbnail" height="2rem">
                <h4 class="card-title">{{ pub.title }}</h4>
                <div class="card-text sobre_text" [innerHTML]=pub.description></div>
                <div class="row w-100 foot-card">
                    <div class="col">
                        <a translate [href]=pub.url class="read-more">
                            <fa-icon icon="link"></fa-icon> publi.read-more
                        </a>
                    </div>
                    <div class="col">
                        <p class="card-text text-right">
                            <small class="text-muted">
                                {{ pub.publicationDate | date:'mediumDate'}}
                            </small>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </ng-container>

    <ng-template #skeletonTemplate>
        <div>
            <div class="card mt-5 text-white bg-dark border-white rounded-0 border-right-0 border-left-0"
                *ngFor="let i of [].constructor(8)">
                <div class="card-body">
                    <ngx-skeleton-loader count="1" class="thumb mr-2 mb-1" [theme]="{
                        'border-radius': '5px',
                        'height': '4rem',
                        'width': '4rem',
                        'background-color': '#323232',
                        'border': '1px solid #323232',
                        'animation-duration': '1.2s'
                      }">
                    </ngx-skeleton-loader>
                    <div class="card-title">
                        <ngx-skeleton-loader count="2" [theme]="{
                        'border-radius': '5px',
                        'width': '18rem',
                        'background-color': '#323232',
                        'border': '1px solid #323232',
                        'animation-duration': '1.2s'
                      }"></ngx-skeleton-loader>
                    </div>
                    <div class="card-text">
                        <ngx-skeleton-loader count="3" [theme]="{
                            'margin-left': '1rem',
                            'border-radius': '5px',
                            'width': '21.5rem',
                            'background-color': '#323232',
                            'border': '1px solid #323232',
                            'animation-duration': '1.2s'
                          }"></ngx-skeleton-loader>
                    </div>
                    <div class="row w-100 foot-card">
                        <div class="col">
                            <ngx-skeleton-loader count="1" [theme]="{
                                'margin-left': '1rem',
                                'border-radius': '5px',
                                'width': '5rem',
                                'background-color': '#323232',
                                'border': '1px solid #323232',
                                'animation-duration': '1.2s'
                              }"></ngx-skeleton-loader>
                        </div>
                        <div class="col">
                            <p class="card-text text-right">
                                <ngx-skeleton-loader count="1" [theme]="{
                                    'margin-left': '1rem',
                                    'border-radius': '5px',
                                    'width': '3rem',
                                    'background-color': '#323232',
                                    'border': '1px solid #323232',
                                    'animation-duration': '1.2s'
                                  }"></ngx-skeleton-loader>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>